import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { listBlocos } from '../Cadastro/BlocoDeOferta/services';
import { deleteProdutoOferta, getOffers, saveOffer, updateOffer } from '../Cadastro/Ofertas/services';

interface UseOffersOptions {
  fetchOffers?: boolean;
}

export const useOffers = (campanhaId: string, params?: any, options?: UseOffersOptions) => {
  const queryClient = useQueryClient();
  const { fetchOffers = true } = options || {};

  const { data: offerBlocks } = useQuery({
    queryKey: ['offerBlocks'],
    queryFn: () => listBlocos(campanhaId, { size: 200 }),
  });

  const { data: offers, refetch: refetchOffers } = useQuery({
    queryKey: ['ofertas', campanhaId, params],
    queryFn: () => getOffers({ id: campanhaId, ...params }, params?.filters),
    enabled: !!campanhaId && fetchOffers,
    keepPreviousData: true,
  });

  const { mutateAsync: createOffer } = useMutation({
    mutationFn: (data: any) => saveOffer(campanhaId, data),
    onSuccess: () => {
      queryClient.invalidateQueries(['ofertas', campanhaId]);
    },
  });

  const { mutateAsync: editOffer } = useMutation({
    mutationFn: ({ data, offerId }: { data: any; offerId: string }) => updateOffer(campanhaId, data, offerId),
    onSuccess: () => {
      queryClient.invalidateQueries(['ofertas', campanhaId]);
    },
  });

  const { mutateAsync: removeOffer } = useMutation({
    mutationFn: (offerId: string) => deleteProdutoOferta(campanhaId, offerId),
    onSuccess: () => {
      queryClient.invalidateQueries(['ofertas', campanhaId]);
    },
  });

  return {
    states: {
      offerBlocks,
      offers,
    },
    handlers: {
      createOffer,
      editOffer,
      removeOffer,
      refetchOffers,
    },
  };
};
